import * as Stitches from '@stitches/react';
import { keyframes, styled } from '@gbm-tech/styles';

const dropdownH = keyframes({
  '0%': { opacity: 0, maxHeight: 0 },
  '100%': { opacity: 1, maxHeight: '20rem' },
});

const ContainerXXXL: Stitches.CSS = {
  span: {
    fontSize: '1.8rem',
    lineHeight: '3.2rem',
  },
};

const ContainerHover: Stitches.CSS = {
  backgroundColor: '#ebf1f5',
  color: '#404a59',
};

export const Container = styled('div', {
  padding: '0.8rem 2.4rem',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1.2rem',

  border: 'none',
  outline: 'none',
  borderBottom: '1.5px solid $blue50',
  backgroundColor: '$gray50',

  textAlign: 'left',
  fontSize: '1.4rem',
  lineHeight: '2.4rem',
  fontWeight: 500,

  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  color: '$gray500',
  textDecoration: 'none',

  cursor: 'pointer',
  userSelect: 'none',
  transition: 'all ease-in-out 0.4s',

  animationDuration: '200ms',
  animationTimingFunction: 'linear',
  animationName: dropdownH.toString(),

  '> .subItemCaretIcon': {
    marginTop: '-0.2rem',
    size: '1.8rem',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    transition: 'transform ease-in-out 0.2s',

    '> svg': {
      size: '100%',
    },

    '&.is-open': {
      transform: 'rotate(90deg)',
    },
  },

  '&:hover': { ...ContainerHover },

  '@xxxl': { ...ContainerXXXL },
});

export const SubPagesCollapsedContainer = styled('div', {
  flexDirection: 'column',

  overflow: 'hidden',

  animationDuration: '300ms',
  animationTimingFunction: 'linear',
  animationName: dropdownH.toString(),

  variants: {
    visible: {
      true: {
        display: 'flex',
      },

      false: {
        display: 'none',
      },
    },
  },
});
